import * as actionTypes from './../Audit_action.types';
import * as api from './../audit_api_services/TemplateMap.api';

  export const getClientMappingRequest = () => ({
      type: actionTypes.GET_TEMPLATE_MAPPING_REQUEST,
  });
  
  export const getClientMappingSuccess = (clients) => ({
    type: actionTypes.GET_TEMPLATE_MAPPING_SUCCESS,
    payload: clients,
  });
  
  export const getClientMappingFailure = (error) => ({
    type: actionTypes.GET_TEMPLATE_MAPPING_FAILURE,
    payload: error,
  });
  
  export const getClientMapping = () => {
    return async (dispatch) => {
      dispatch(getClientMappingRequest());
      try {
        const response = await api.fetchClientMapping();
        dispatch(getClientMappingSuccess(response));
        return { success: true, data: response };
      } catch (error) {
        dispatch(getClientMappingFailure(error));
        return { success: false, message: error };
      }
    };
  };
  
  export const createSingleClientMappingRequest = (fileData) => ({
      type: actionTypes.CREATE_TEMPLATE_MAPPING_REQUEST,
      payload: fileData,
  });

export const createSingleClientMappingSuccess = (fileData) => ({
  type: actionTypes.CREATE_TEMPLATE_MAPPING_SUCCESS,
  payload: fileData,
});

export const createSingleClientMappingFailure = (error) => ({
  type: actionTypes.CREATE_TEMPLATE_MAPPING_FAILURE,
  payload: error,
});

export const createSingleClientMapping = (fileData) => {
  return async (dispatch) => {
    dispatch(createSingleClientMappingRequest(fileData));
    try {
      const response = await api.addSingleClientMapping(fileData);
      dispatch(createSingleClientMappingSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(createSingleClientMappingFailure(error));
      return { success: false, message: error };
    }
  };
};
  export const multiDaleteClientMappingRequest = (ids) => ({
    type: actionTypes.MULTIDELETE_TEMPLATE_MAPPING_REQUEST,
    payload: ids,
  });
  
  export const multiDaleteClientMappingSuccess = (message) => ({
    type: actionTypes.MULTIDELETE_TEMPLATE_MAPPING_SUCCESS,
    payload: message,
  });
  
  export const multiDaleteClientMappingFailure = (error) => ({
    type: actionTypes.MULTIDELETE_TEMPLATE_MAPPING_FAILURE,
    payload: error,
  });
  
  export const multiDeleteClientMapping = (ids) => {
    return async (dispatch) => {
      dispatch(multiDaleteClientMappingRequest(ids));
      try {
        const response = await api.multiDeleteClientMapping(ids);
        dispatch(multiDaleteClientMappingSuccess(response));
        return { success: true, message: response };
      } catch (error) {
        dispatch(multiDaleteClientMappingFailure(error));
        return { success: false, message: error };
      }
    };
  };
  
  
  export const updateClientMappingRequest = (id, clientData) => ({
    type: actionTypes.UPDATE_TEMPLATE_MAPPING_REQUEST,
    payload: { id, clientData },
  });
  
  export const updateClientMappingSuccess = (message) => ({
    type: actionTypes.UPDATE_TEMPLATE_MAPPING_SUCCESS,
    payload: message,
  });
  
  export const updateClientMappingFailure = (error) => ({
    type: actionTypes.UPDATE_TEMPLATE_MAPPING_FAILURE,
    payload: error,
  });
  
  export const updateClientMappingById = (id, salaryData) => {
    return async (dispatch) => {
      const user = JSON.parse(sessionStorage.getItem('user'));
      salaryData.updated_by = user.user_name;
  
      dispatch(updateClientMappingRequest(id, salaryData));
      try {
        const response = await api.updateClientMapping(id, salaryData);
        dispatch(updateClientMappingSuccess(response.message));
        return { success: true, message: response.message };
      } catch (error) {
        dispatch(updateClientMappingFailure(error));
        return { success: false, message: error };
      }
    };
  };
  export const deleteClientMappingRequest = (id) => ({
    type: actionTypes.DELETE_TEMPLATE_MAPPING_REQUEST,
    payload: id,
  });
  
  export const deleteClientMappingSuccess = (message) => ({
    type: actionTypes.DELETE_TEMPLATE_MAPPING_SUCCESS,
    payload: message,
  });
  
  export const deleteClientMappingFailure = (error) => ({
    type: actionTypes.DELETE_TEMPLATE_MAPPING_FAILURE,
    payload: error,
  });
  
  export const deleteClientMappingById = (id) => {
    return async (dispatch) => {
      dispatch(deleteClientMappingRequest(id));
      try {
        const response = await api.deleteClientMapping(id);
        dispatch(deleteClientMappingSuccess(response.message));
        return { success: true, message: response.message };
      } catch (error) {
        dispatch(deleteClientMappingFailure(error));
        return { success: false, message: error };
      }
    };
  };

  export const getClientWiseTemplateRequest = (client) => ({
    type: actionTypes.GET_TEMPLATE_MAPPING_REQUEST,
    payload: client,
});

export const getClientWiseTemplateSuccess = (clients) => ({
  type: actionTypes.GET_TEMPLATE_MAPPING_SUCCESS,
  payload: clients,
});

export const getClientWiseTemplateFailure = (error) => ({
  type: actionTypes.GET_TEMPLATE_MAPPING_FAILURE,
  payload: error,
});

export const getClientWiseTemplate = (client) => {
  return async (dispatch) => {
    dispatch(getClientWiseTemplateRequest(client));
    try {
      const response = await api.fetchClientWiseTemplate(client);
      dispatch(getClientWiseTemplateSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getClientWiseTemplateFailure(error));
      return { success: false, message: error };
    }
  };
};





  export const fetchClientWiseTemplateRequest = (client) => ({
    type: actionTypes.GET_TEMPLATE_MAPPING_REQUEST,
    payload: client,
});

export const fetchClientWiseTemplateSuccess = (clients) => ({
  type: actionTypes.GET_TEMPLATE_MAPPING_SUCCESS,
  payload: clients,
});

export const fetchClientWiseTemplateFailure = (error) => ({
  type: actionTypes.GET_TEMPLATE_MAPPING_FAILURE,
  payload: error,
});

export const fetchClientWiseMapTemplate = (client) => {
  return async (dispatch) => {
    dispatch(fetchClientWiseTemplateRequest(client));
    try {
      const response = await api.fetchClientMapTemplate(client);
      dispatch(fetchClientWiseTemplateSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(fetchClientWiseTemplateFailure(error));
      return { success: false, message: error };
    }
  };
};